<template>
    <div>
        <SectionHead />
        <div class="container-fluid container-head">
            <div class="row">
                <div class="col-md-4 d-flex flex-column align-self-stretch">
                    <div class="col-md-12">
                            <PersonalData/>
                    </div>
                    <div class="col-md-12">
                        <OrderData @resetFiles="handleClearPdf"/>
                    </div>
                </div>
                <div class="col-md-8 d-flex flex-column align-self-stretch">
                    <File ref="fileComponent"/>
                </div>
             
            </div>
        </div>

    </div>
</template>
  
<script>
import SectionHead from '@/components/order/Section.vue'
import PersonalData from '@/components/order/PersonalData.vue'
import OrderData from '@/components/order/OrderData.vue'
import File from '@/components/order/File.vue'

export default {
    name: 'index',
    components: {
        SectionHead,PersonalData,OrderData,File
    },
    mounted() {
        this.$swal("Tío Toto", "¡Gracias por elegirnos! Por la alta demanda de pedidos estamos operando con tiempos de entrega de 24hs hábiles. Seguimos trabajando para atenderte de la mejor manera. ¡Gracias por tu paciencia!" , "info");
    },
    data() {
        return {
        }
    },
    computed: {

    },
    methods: {
        handleClearPdf() {
            this.$refs.fileComponent.clearPdfFiles();
        }
    }
}
</script>
  
<style scoped></style>
  